import { createIcon } from "@chakra-ui/react";

export const Cross = createIcon({
  displayName: "Cross",
  viewBox: "0 0 24 24",
  d: "M18.586 16.61a1.401 1.401 0 0 1-1.981 1.98L12 13.98l-4.61 4.606a1.402 1.402 0 0 1-1.98-1.981L10.02 12 5.413 7.39a1.401 1.401 0 0 1 1.981-1.98L12 10.02l4.61-4.606a1.401 1.401 0 0 1 1.98 1.981L13.98 12l4.606 4.61z",
  defaultProps: {
    "aria-label": "A cross"
  }
});

export default Cross;
